import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20reading%20atmosphere%2C%20warm%20cozy%20digital%20reading%20environment%2C%20soft%20ambient%20lighting%2C%20abstract%20artistic%20background%20with%20warm%20amber%20and%20cream%20tones%2C%20minimalist%20design%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=1800&height=900&seq=manhwa-hero-bg&orientation=landscape"
        alt="韩漫网"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
            韩漫在线观看
            <span className="block text-primary-400 mt-2">漫画免费下拉式阅读</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed">
            收录好看韩国漫画全集，涵盖恋爱、奇幻、动作、悬疑等多种热门类型
            <br className="hidden sm:block" />
            高清画质，丝滑下拉式阅读，每日更新，畅享韩漫世界
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="relative w-full sm:w-96">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你喜欢的漫画..."
                className="w-full px-5 py-3.5 pl-12 rounded-full bg-background-50/95 text-foreground-800 text-sm placeholder:text-foreground-400 border border-background-200/50 focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all"
              />
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg w-5 h-5 flex items-center justify-center"></i>
            </div>
            <Link
              to="/category/romance"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
            >
              立即阅读
            </Link>
          </div>

          <div className="mt-8 flex items-center justify-center gap-6 text-sm text-background-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-book-read-line w-4 h-4 flex items-center justify-center"></i>
              12,800+ 部漫画
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
              580万+ 读者
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-timer-line w-4 h-4 flex items-center justify-center"></i>
              每日更新
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}